<template>
  <v-chip
    :color="meta.color"
    small
    label
    outlined
    class="font-weight-bold"
  >
    <v-icon
      left
      small
    >
      {{ meta.icon }}
    </v-icon>
    {{ meta.label }}
  </v-chip>
</template>

<script>
import { computed } from '@vue/composition-api'
import {
  mdiAlertCircle,
  mdiAlert,
  mdiTimerSand,
  mdiCheckCircle,
} from '@mdi/js'

// シート状態 → 表示メタ（モック closing-page.html の STATUS 定義に対応）
const STATUS_META = {
  error: { label: 'エラー', color: 'error', icon: mdiAlertCircle },
  unsaved: { label: '未保存', color: 'warning', icon: mdiAlert },
  progress: { label: '集計中', color: 'secondary', icon: mdiTimerSand },
  saved: { label: '保存済み', color: 'success', icon: mdiCheckCircle },
}

export default {
  name: 'SheetStatusChip',
  props: {
    status: {
      type: String,
      default: 'saved',
    },
  },
  setup(props) {
    const meta = computed(() => STATUS_META[props.status] || STATUS_META.saved)

    return { meta }
  },
}
</script>
